import React, { Component } from 'react';
import { Group, Rect, Text } from 'react-konva';

export class SmsBusComponentCanvas extends Component {
    render() {
        const { geometry, component, isSelected, dimentionsRatio, draggable } = this.props;

        const resizedWidth = geometry.width * dimentionsRatio;
        const resizedHeight = geometry.height * dimentionsRatio;
        
        let fontSize = resizedHeight * 0.8;
        if(fontSize > resizedWidth) {
            fontSize = resizedWidth - 10;
        }

        return (
            <Group
                offsetX={geometry.offsetX}
                offsetY={geometry.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId) : null} >
                <Rect x={geometry.drawPositionX}
                    y={geometry.drawPositionY}
                    width={resizedWidth}
                    height={resizedHeight}
                    strokeWidth={isSelected ? 3 : 1}
                    stroke={isSelected ? "#6699ff" : "black"}
                    fill={component.color} />
                <Text
                    text="&#x2709;"
                    fontSize={fontSize}
                    fontFamily="Glyphicons Halflings"
                    fill="#F5FAFC"
                    x={geometry.drawPositionX + (resizedWidth / 2.0) - (fontSize / 2.0)}
                    y={geometry.drawPositionY + (resizedHeight / 2.0) - (fontSize / 3.5)} />
            </Group>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/componentCanvas/SmsBusComponentCanvas.js